import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventDetailService {
  apiUrl: string = environment.PROCUREMENT_API_SERVER;
  bidderEventDetails: any;
  submissionSlipDetails: any;
  bidder: any;
  updateSelected = [];
  constructor(private _httpClient: HttpClient) {}

  createEventDetails(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`,
      payload.body
    );
  }

  getAllEventDetails(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-event-details/get-all-procurement-tenders-event-details/`,
      {
        params: payload.params,
      }
    );
  }
  exportEventDetails(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-event-details/export/`,
      {
        params: payload.params,
        responseType: 'blob',
      }
    );
  }

  getEventDetail(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-event-details/get-procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`
    );
  }
  updateCompliance(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-event-details/update-compliance/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`
    );
  }

  deleteEventDetails(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/procurement-tender-event-details/delete-procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`
    );
  }

  addBidderFromIrr(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-tender-event-details/fromIrrRef/${payload.irrRef}`,
      payload.body
    );
  }

  updateContactDetails(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/procurement-tender-event-details/edit-procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`,
      payload.body
    );
  }
  editIrr(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-tender-event-details/update-irr/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}`,
      payload.body
    );
  }

  updateShortlist(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}/shortlist/${payload.shortListed}`,
      payload.body
    );
  }
  updateWinner(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/procurement-tender-event-details/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}/winning/${payload.won}`,
      payload.body
    );
  }
}
